import { useState } from 'react';
import { Icon } from '@/components/Icon';
import s from './Thumb.module.css';

/**
 * 图片地址：老系统上传后存的是 `/uploads/<文件名>`（同源，由老后端按权限输出，见 src/app/uploads/[filename]）。
 * 开发期 vite 把 /uploads 代理到老后端，生产由 Caddy 反代到老系统，所以同源路径原样用；外链原样用；
 * 只有裸文件名（历史数据）才补 /uploads/ 前缀。
 */
export function imageSrc(url?: string | null) {
  const u = url?.trim();
  if (!u) return undefined;
  if (/^(https?:|data:|blob:)/i.test(u) || u.startsWith('/')) return u;
  return `/uploads/${u}`;
}

type WithImages = { coverImageUrl?: string | null; images?: { url: string; thumbnailUrl?: string | null; type?: string }[] };

/**
 * 产品主图，规则照老页面：COVER 类型的图 → coverImageUrl；
 * 画册（anyImage）再退到第一张图（老 gallery/page.tsx getPrimaryImage）。
 */
export function productCover(p: WithImages, anyImage = false) {
  const imgs = p.images || [];
  return imageSrc(imgs.find((i) => i.type === 'COVER')?.url || p.coverImageUrl || (anyImage ? imgs[0]?.url : undefined));
}

/** 套装封面：第一张图的缩略图 → 原图（老 bundles/page.tsx getBundleCoverImage） */
export function bundleCover(b: { images?: { url: string; thumbnailUrl?: string | null }[] }) {
  const first = b.images?.[0];
  return imageSrc(first?.thumbnailUrl || first?.url);
}

/** 没有图片记录时显示中性占位；已有图片地址加载失败时用红色告警；画册方图缺图写「暂无图片」。 */
export function Thumb({ src, alt, size = 48, square, className, fallbackIcon = 'img' }: { src?: string; alt: string; size?: number; square?: boolean; className?: string; fallbackIcon?: string }) {
  const [bad, setBad] = useState(false);
  const unavailable = !src || bad;
  const style = square ? undefined : { width: size, height: size };
  return (
    <span className={[s.th, bad && s.miss, square && s.sq, className].filter(Boolean).join(' ')} style={style} title={bad ? '图片加载失败' : !src ? '缺图片' : undefined}>
      {unavailable ? (square ? <i><Icon name={fallbackIcon} size={24} />暂无图片</i> : <Icon name={fallbackIcon} size={18} />) : <img src={src} alt={alt} loading="lazy" onError={() => setBad(true)} />}
    </span>
  );
}
